import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/home/header.tsx");
